// extracted by mini-css-extract-plugin
export default {"container":"LoyaltyTooltip_container__Q5DKw","inner":"LoyaltyTooltip_inner__vFcbF","title":"LoyaltyTooltip_title__Qp4jR","no":"LoyaltyTooltip_no__tqujH"};